import React, { memo, useEffect, useState, useCallback } from 'react'
import InputBase from '@material-ui/core/InputBase'
import { makeStyles } from '@material-ui/core'
import { useApolloClient } from '@apollo/react-hooks'

import { AddCompanyLocations } from 'store'
import { AvailableLocations } from './'
import { useDebounce } from 'utils'
import { ECompanyActionTypes } from 'models'
import styles from './styles'
import { StoreValue } from 'store'

const useStyles = makeStyles(styles)
const SearchContainerView: React.FunctionComponent<any> = props => {
	const {
		placeholder,
		storeDispatch,
		headquartersOfficeType,
		headquarters,
	} = props
	const classes = useStyles()
	const client = useApolloClient()
	const [inputLocation, setInputLocation] = useState<String>('')

	const debouncedSearchTerm = useDebounce(inputLocation, 500)
	const handleSearchChange = useCallback((event: any) => {
		if (event && event.target) setInputLocation(event.target.value)
		else setInputLocation('')
	}, [])

	const populateLocationsState = useCallback(
		(locations: any[]) => {
			if (headquartersOfficeType) {
				storeDispatch({
					type: ECompanyActionTypes.setPopulateHeadquarters,
					headquarters: { availableLocations: locations },
				})
			} else {
				storeDispatch({
					type: ECompanyActionTypes.setPopulateOffices,
					offices: { availableLocations: locations },
				})
			}
			setLoading(false)
		},
		[storeDispatch, headquartersOfficeType],
	)
	const [loading, setLoading] = useState(false)

	const fetchSearchResult = useCallback(async () => {
		if (inputLocation.length === 0) {
			setLoading(false);
			return

		}
		const { data: searchResult } = await client.query({
			query: AddCompanyLocations,
			variables: {
				data: {
					name: inputLocation,
					type_in: [
						'Comună',
						'Oraş',
						'Municipiu',
						'National capital',
					],
				},
			},
		})
		const locations = searchResult && searchResult.roLocations
		populateLocationsState(locations)
	}, [client, inputLocation, populateLocationsState])

	useEffect(() => {
		if (debouncedSearchTerm) {
			setLoading(true)
			fetchSearchResult()
			// setLoading(false)
		} else {
			populateLocationsState([])
		}
	}, [
		debouncedSearchTerm,
		inputLocation,
		populateLocationsState,
		fetchSearchResult,
	])

	return (
		<div className={classes.root}>
			<div>
				<InputBase
					onChange={handleSearchChange}
					placeholder={placeholder}
					inputProps={{
						className: classes.input,
					}}
					value={inputLocation}
					disabled={
						headquartersOfficeType &&
						headquarters.selected.length > 0
					}
				/>
			</div>
			<div className={classes.availableLocations}>
				{
					<AvailableLocations
						headquartersOfficeType={headquartersOfficeType}
						pristine={inputLocation.length !== 0}
						loading={loading}
						handleSearchChange={handleSearchChange}
					/>
				}
			</div>
		</div>
	)
}

const SearchContainer = memo((props: any) => (
	<StoreValue
		keys={[
			'company.offices|offices',
			'company.headquarters|headquarters',
			'storeDispatch',
		]}
	>
		<SearchContainerView {...props} />
	</StoreValue>
))

export default SearchContainer
